module.exports = __webpack_public_path__ + "static/media/107_customapps.67b60564.png";